import {useNavigation} from '@react-navigation/native';
import * as React from 'react';
import Screen from '../../../../../shared/components/screen';
import {CustomScrollView} from '../../../../../shared/components/scrollView';
import {PhoneConfirmation} from '../../../common/phoneConfirmation';

export default () => {
  const navigation = useNavigation();
  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <PhoneConfirmation navigation={navigation as any} />
      </CustomScrollView>
    </Screen>
  );
};
